import _ from 'lodash'

export default ({
  path,
  queryPath,
  data: { [queryPath]: items },
  values: { [path]: values },
  isSelected,
}) => _.reject(items, (item) => isSelected({ item, values }))
